import React from 'react';
import PropTypes from 'prop-types';

const ModalNotificationConfirm = ({ children }) => (
  <div className="ui--modal-notificationsC active">
    <div>
      <section>
        {children}
        {/* <a className="close" onClick={toggle}>{xclose}</a> */}
      </section>
    </div>
  </div>
);

ModalNotificationConfirm.propTypes = {
  children: PropTypes.node.isRequired,
};


export default (ModalNotificationConfirm);
